<template>
  <router-view></router-view>
</template>


<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('_Notifier', ['notifsPersistantes'])
  },

  created () {
    this.updateDocumentTitle()
  },

  watch: {
    '$route.name': function (v) {
      this.updateDocumentTitle()
    },
    notifsPersistantes: function (v) {
      this.updateDocumentTitle()
    }
  },

  methods: {
    updateDocumentTitle () {
      let title = this.$route.meta.title
        ? this.$tc(this.$route.meta.title, 2, { count: '' })
        : this.$tc(this.$route.name, 2, { count: '' })
      title = title.charAt(0).toUpperCase() + title.slice(1)
      let notif = this.notifsPersistantes.length
      let notifStr = notif ? '(' + notif + ') ' : ''
      document.title = notifStr + title
      let faviconDefault = './static/icon_tf.png'
      let faviconNotif = './static/icon_tf_notif.png'
      if (notif) {
        changeFavicon(faviconNotif)
      } else {
        changeFavicon(faviconDefault)
      }
    }
  }
}
function changeFavicon (src) {
  let link = document.createElement('link')
  let oldLink = document.getElementById('dynamic-favicon')
  link.id = 'dynamic-favicon'
  link.rel = 'shortcut icon'
  link.href = src
  if (oldLink) {
    document.head.removeChild(oldLink)
  }
  document.head.appendChild(link)
}
</script>



// WEBPACK FOOTER //
// src/App.vue